import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../Config";
import { useTranslation } from 'react-i18next';

function ResetPassword() {
  const { t } = useTranslation();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false); 

  const validatePassword = (password) => {
    const minLength = /.{8,}/;
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;
    const hasUppercase = /[A-Z]/;
    const hasLowercase = /[a-z]/;

    if (!minLength.test(password)) {
      return t('password_min_length');
    }
    if (!hasSymbol.test(password)) {
      return t('password_symbol');
    }
    if (!hasUppercase.test(password)) {
      return t('password_uppercase');
    }
    if (!hasLowercase.test(password)) {
      return t('password_lowercase');
    }
    return null;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (password !== confirmPassword) {
      setError(t('password_mismatch'));
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/reset_password/${token}/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.detail || t('reset_password_error'));
      } else {
        setMessage(t('reset_password_success'));
        setPassword("");
        setConfirmPassword("");
        setError(null);
      }
    } catch (error) {
      setError(t('reset_password_error'));
      console.error(`${t('reset_password_error')}:`, error);
    }
  };

  return (
    <Container className="pt-4">
      <Row>
        <Col lg={5} md={6} className="align-items-center m-auto">
          <h2 className="h4 mb-4">{t('reset_password')}</h2>
          <Form onSubmit={handleSubmit} className="p-4 mt-4 mt-md-0 m-auto forms">
            {message && (
              <Alert variant="success" onClose={() => setMessage(null)} dismissible>
                {message}
              </Alert>
            )}
            {error && (
              <Alert variant="danger" onClose={() => setError(null)} dismissible>
                {error}
              </Alert>
            )}
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>{t('new_password')}</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
              <Form.Label>{t('confirm_new_password')}</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check 
                type="checkbox" 
                id="showPasswordCheckbox"
                label={<label htmlFor="showPasswordCheckbox" style={{ cursor: "pointer" }}>{t('show_password')}</label>}
                onChange={() => setShowPassword(!showPassword)} 
              />
            </Form.Group>                    
            <Button variant="primary" type="submit" className="mb-3 me-2" title={t('submit')}>
              {t('submit')}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
